// Agent adherence performance reports for Nippon dashboard (companyId: 69fdafaff0596b391f8be07b).
// HTML files must be placed in: public/agent-reports/<filename>.html
// To add a new agent: copy their HTML to public/agent-reports/ and add an entry below.

const nipponAgentReports = [
  {
    agentName: "Neeraj Tiwari",
    reportFile: "/agent-reports/neeraj-tiwari-performance-report.html",
    latestScore: 54.38,
    baselineScore: 42.05,
    movement: 12.33,
    totalCalls: 7,
    bestScore: 57.81,
    lowestScore: 33.15,
    dateRange: { from: "2026-05-18", to: "2026-05-29" },
  },
  {
    agentName: "Bikas Das",
    reportFile: "/agent-reports/bikas-das-performance-report.html",
    latestScore: 48.63,
    baselineScore: 44.25,
    movement: 4.38,
    totalCalls: 10,
    bestScore: 53.56,
    lowestScore: 24.79,
    dateRange: { from: "2026-05-19", to: "2026-05-30" },
  },
  {
    agentName: "Azim",
    reportFile: "/agent-reports/azim-performance-report.html",
    latestScore: 43.97,
    baselineScore: 39.86,
    movement: 4.11,
    totalCalls: 3,
    bestScore: 46.30,
    lowestScore: 33.42,
    dateRange: { from: "2026-05-18", to: "2026-05-29" },
  },
  {
    agentName: "Viren Pandya",
    reportFile: "/agent-reports/viren-pandya-performance-report.html",
    latestScore: 46.16,
    baselineScore: 47.53,
    movement: -1.38,
    totalCalls: 15,
    bestScore: 58.22,
    lowestScore: 34.66,
    dateRange: { from: "2026-05-19", to: "2026-05-30" },
  },
  {
    agentName: "Faheem",
    reportFile: "/agent-reports/faheem-performance-report.html",
    latestScore: 40.68,
    baselineScore: 38.04,
    movement: 2.64,
    totalCalls: 8,
    bestScore: 43.29,
    lowestScore: 33.70,
    dateRange: { from: "2026-05-18", to: "2026-05-30" },
  },
  {
    agentName: "Mukesh Singh",
    reportFile: "/agent-reports/mukesh-singh-performance-report.html",
    latestScore: 36.44,
    baselineScore: 45.55,
    movement: -9.11,
    totalCalls: 3,
    bestScore: 50.68,
    lowestScore: 36.44,
    dateRange: { from: "2026-05-28", to: "2026-05-30" },
  },
  {
    agentName: "Vikas Singh",
    reportFile: "/agent-reports/vikas-singh-performance-report.html",
    latestScore: 34.66,
    baselineScore: 33.70,
    movement: 0.96,
    totalCalls: 11,
    bestScore: 70.96,
    lowestScore: 28.63,
    dateRange: { from: "2026-05-18", to: "2026-05-30" },
  },
];

export default nipponAgentReports;
